import { jsx as _jsx } from "react/jsx-runtime";
import { useField } from "formik";
import RequestMultiFactorToken from "./RequestMultiFactorToken";
import { useIsUserAuthenticatedQuery } from "generated/generated-models";
const RequestMultiFactorTokenFormik = (props) => {
    const [, meta, helpers] = useField(props);
    const { data: authenticatedData } = useIsUserAuthenticatedQuery();
    const isUsingGoogleAuth = authenticatedData?.userSession?.IsUsingGoogleAuth || false;
    const getError = () => {
        if (meta.touched && meta.error != null && meta.error !== "") {
            return meta.error;
        }
        else {
            return undefined;
        }
    };
    const handleTokenUpdate = (token) => {
        helpers.setValue(token);
    };
    return (_jsx(RequestMultiFactorToken, { getToken: handleTokenUpdate, errorMessage: getError(), showRequestNewToken: props.showRequestNewToken, requestMfaOnDisplay: props.requestMfaOnDisplay, visible: props.visible, isUsingGoogleAuth: isUsingGoogleAuth }));
};
export default RequestMultiFactorTokenFormik;
